import FlintIconButton from "../../controls/FlintIconButton";
import {ButtonFillMode, ThemeColoursType, VivoPortal} from "@utils/AppConstants";
import EnumIconButtonDefaultType = VivoPortal.EnumIconButtonDefaultType;
import {GridCustomCellProps} from "@progress/kendo-react-grid";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as icons from "@fortawesome/free-solid-svg-icons"
import {Link} from "react-router-dom";
import {HTMLAttributeAnchorTarget} from "react";
import "./GridActionColumnCell.scss"
export default function GridActionColumnCell(props: GridActionColumnProps) {
    return (
        <td {...props.tdProps}>
            <div className="btn-column justify-content-end">
                {props.columns.map((column, i) => {
                    if (column.isItemHidden?.(props.dataItem) == true)
                        return;
                    let url = column.url?.href;
                    if (column.url && column.url.paramPropertyName){
                        url = url + props.dataItem[column.url.paramPropertyName];
                    }
                    return <div key={i} className={"position-relative"}>
                        {column.url &&
                            <Link to={url!} target={column.url.target} className={"url-action-button"}>
                                <FlintIconButton iconEnum={column.type} title={column.title}
                                                 fillMode={column.buttonFillMode}
                                                 themeColor={column.buttonThemeColor}/>
                                <FontAwesomeIcon size={"2xs"} icon={icons.faLink} className={"url-icon"}/>
                            </Link>
                        }
                        {column.url == null &&
                            <FlintIconButton iconEnum={column.type} title={column.title}
                                             fillMode={column.buttonFillMode}
                                             themeColor={column.buttonThemeColor} onClick={() => {
                                if (!column.onClick)
                                    return;
                                column?.onClick(props.dataItem);
                            }}/>}
                    </div>
                })}
            </div>
        </td>
    );
}

export interface GridActionColumnProps extends GridCustomCellProps {
    columns: actionColumn[]
}

export interface actionColumn {
    type: EnumIconButtonDefaultType;
    onClick?: (dataItem: any) => void;
    isItemHidden?: (dataItem: any) => boolean;
    title?: string;
    buttonThemeColor?: ThemeColoursType;
    buttonFillMode?: ButtonFillMode;
    /** when we want the button to act as an url */
    url?: {
        href: string,
        target?: HTMLAttributeAnchorTarget,
        /** f.ex. passing 'Guid' will cause that at the end of href a value of "dataItem.Guid" will be added. href should end with '/' in such case! */
        paramPropertyName?: string
    }
}